import Image from 'next/image';
import type { BenefitIconName } from './MembershipBenefits.types';

export function BenefitIcon({
  name,
  className,
}: {
  name: BenefitIconName;
  className?: string;
}) {
  return (
    <Image
      src={`/bank-of-america/icon-${name}.svg`}
      alt=''
      width={80}
      height={80}
      className={className}
    />
  );
}
